(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-sticker-lt"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticker-animated')) {
    class StickerAnimated extends HTMLElement {
      constructor() {
        super()
        this.animationSpeed = parseFloat(this.dataset.animationSpeed)

        this.init()

        document.addEventListener('readystatechange', function() {
          if(document.readyState == 'interactive') {
          }
        })
        document.addEventListener("shopify:section:load", (event) => {
          this.init()
        });
      }
      init() {
        this.selecter = ".stckrimg"
        this.stckrimgs = this.querySelectorAll(this.selecter);
        this.scroll();
      }
      scroll() {
        Array.from(this.stckrimgs).forEach(stckrimg => {
          window.addEventListener("scroll", () => {
            const section = stckrimg.closest(`.shopify-section`)
            const LT__section = stckrimg.closest(`.luna-templates__animated-sticker`)
            const sticker = this.querySelector('.luna-templates-animated-sticker');
            const {bottom, top} = sticker.getBoundingClientRect();

            if (top > 0 && (bottom - window.innerHeight) < 0) {
              if (LT__section.dataset.animation == "spin-scroll") {
                stckrimg.style.rotate = (bottom * this.animationSpeed) + "deg";
                stckrimg.style.top = 0 + "px";
              }

              if (LT__section.dataset.animation == "float-scroll") {
                stckrimg.style.rotate = 0 + "deg";
                // stckrimg.style.top = ((bottom + (window.innerHeight / 2)) * this.animationSpeed) + "px";
                stckrimg.style.top = (((sticker.offsetTop + this.offsetTop) - (window.scrollY + (window.innerHeight / 2))) * this.animationSpeed) + "px";
              }
            }
          }, {
            passive: true,
            capture: false,
          })
        })
      }
    }
    customElements.define('sticker-animated', StickerAnimated)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creative-typography"] && !Shopify.designMode) return;
  try {
    
  if(typeof LunaWords !== 'function') {
    class LunaWords extends HTMLElement {
      constructor() {
        super()

        this.init()
        document.addEventListener("shopify:section:load", (event) => {
          this.init();
        });
      }
      init() {
        this.idx = 0
        this.template = this.querySelector('template').content.cloneNode(true)
        const div = document.createElement('div')
        div.className = 'lt-creative_typography-title'
        div.innerHTML = this.processContent(this.template.querySelector('.luna-templates_html').innerHTML);
        div.append(...this.template.querySelector('.luna-templates_blocks').childNodes);

        this.querySelector('.lt-creative_typography-title')?.remove()
        this.append(div)
      }
      processContent(html) {
        return html.replace(/(<[^>]+>.*?<\/[^>]+>)|(\S+)/g, (match, tag) => {
          this.idx += 1
          if(tag) {
            const newtag = tag.replace(/<([a-zA-Z0-9]+)([^>]*?)>(.*?)<\/\1>/g, (_, inner_tag, attrs, content) => content.split(' ').map((word, i) => {
              if(i != 0) this.idx += 1
              const c = `<span class="lt-creative_typography-word" style="order: ${ this.idx }"><${inner_tag}${attrs}>${word}</${inner_tag}></span>`

              return c
            }).join(' '));
            return newtag
          } else {
            return `<span class="lt-creative_typography-word" style="order: ${ this.idx }">${ match }</span>`
          }
        });
      }
    }

    customElements.define('luna-words', LunaWords)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticker-stack"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-sticker-float')) {
    class TdStickerFloat extends HTMLElement {
      connectedCallback() {
        this.stickers = this.querySelectorAll('.td-sticker-img');
        window.addEventListener('scroll', () => this.onScroll(), { passive: true });
        this.onScroll();
      }
      onScroll() {
        this.stickers.forEach(sticker => {
          const speed = parseFloat(sticker.dataset.speed);
          const rect = sticker.getBoundingClientRect();
          const centerY = rect.top + rect.height / 2;
          const offset = (centerY - window.innerHeight / 2) * speed;
          sticker.style.transform = `rotate(${sticker.dataset.rotate}deg) translateY(${offset}px)`;
        });
      }
    }
    customElements.define('td-sticker-float', TdStickerFloat);
  }

  } catch(e) { console.error(e); }
})();
})();
